const icons = {
    unlock: 61440,
    lock: 61441,
    mail: 61442,
    calendar: 61443,
    addcalendar: 61444,
    clock: 61445,
    location: 61446,
    share: 61447,
    star: 61448,
    heart: 61449,
    help: 61456,
    home: 61457,
    bookmark: 61458,
    bookmarked: 61459,
    search: 61460,
    repeating: 61461,
    filter: 61462,
    friends: 61463,
    cash: 61464,
    credit_card: 61465,
    list: 61472,
    city: 61473,
    tickets: 61474,
    settings: 61475,
    write: 61476,
    event: 61477,
    globe: 61478,
    phone: 61479,
    link: 61480,
    person: 61481,
    webpage: 61490,
    chatbubbles: 61491,
    chart: 61492,
    photo: 61493,
    gallery: 61494,
    camera: 61495,
    circle_cross: 61591,
    cross: 61496,
    checkmark: 61497,
    circle_checkmark: 61719,
    print: 61504,
    receipt: 61505,
    trash: 61506,
    gripper: 61507,
    computer: 61508,
    invisible: 61509,
    refresh: 61510,
    addperson: 61720,
    circle_plus: 61720,
    playvideo: 61728,
    plus: 61511,
    minus: 61512,
    upload: 61513,
    download: 61520,
    circle_play: 61728,
    play: 61521,
    ticket: 61522,
    document: 61523,
    copy: 61524,
    save: 61525,
    previous_location: 61526,
    hurry: 61527,
    frown: 61528,
    menu: 61536,
    promote: 61537,
    tablet: 61538,
    cellphone: 61539,
    add_many: 61540,
    compass: 61541,
    coffee: 61542,
    section: 61543,
    section_right: 61588,
    section_justified: 61589,
    section_left: 61587,
    table: 61544,
    not_seated: 61545,
    object: 61552,
    stage: 61552,
    text: 61553,
    drink: 61554,
    bar: 61554,
    food: 61555,
    exit: 61556,
    bathroom: 61557,
    dance: 61558,
    dancefloor: 61558,
    resize_grave: 61559,
    resize_aigu: 61560,
    rotate: 61561,
    square: 61568,
    open_circle: 61569,
    line: 61570,
    focal_on: 61571,
    focal_off: 61572,
    bold: 61573,
    italic: 61574,
    strikethrough: 61575,
    headline: 61576,
    list_ol: 61577,
    undo: 61584,
    redo: 61585,
    move: 61586,
    view_event_page: 61590,
    scan: 61592,
    tiki: 61696,
    status_private: 61698,
    signal: 61699,
    team_created: 61716,
    information: 61717,
    info: 61717,
    circle_minus: 61721,
    error: 61721,
    success: 61719,
    alert: 61729,
    solid_circle: 61744,
    seated: 61745,
    music: 62464,
    sports: 62465,
    fundraising: 62466,
    political: 62467,
    conferences: 62544,
    fairs: 62545,
    classes: 62546,
    eventbrite_logo: 61952,
    eventbrite_badge: 61953,
    facebook_logo: 61956,
    facebook_badge: 61957,
    twitter_badge: 61958,
    google_plus_badge: 61959,
    rss_badge: 61960,
    linkedin_badge: 61961,
    email_badge: 61968,
    chat_badge: 61969,
    instagram_badge: 61970,
    link_badge: 61971,
    phone_badge: 61972,
    outlook_badge: 61973,
    google_calendar_badge: 61974,
    apple_calendar_badge: 61975,
    yahoo_badge: 61976,
    arrow_up: 62208,
    arrow_right: 62209,
    arrow_down: 62210,
    arrow_left: 62211,
    arrow_dropdown: 62212,
    omnes_arrow_up: 62213,
    omnes_arrow_right: 62214,
    omnes_arrow_down: 62215,
    omnes_arrow_left: 62216,
};

const transformedIcons = {};

const keys = Object.keys(icons);

keys.forEach((key) => {
    transformedIcons[key] = String.fromCharCode(icons[key]);
});

export default transformedIcons;
